@if(hasResultDocument() || hasRegHubDocument() || uboTreeNode?.document) {
  <div class="flex-container">
    @if (buttonVariant === 'stroked') {
      <button type="button" mat-stroked-button color="primary" class="right-icon-button" [class.spinner]="isSaving" [disabled]="isSaving"
        [attr.aria-label]="'common.labels.downloadResultDocument' | transloco" data-testid="result-document-button" [matMenuTriggerFor]="downloadMenu">
        <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">keyboard_arrow_down</mat-icon>
        <mat-label>{{ labels.documents }}</mat-label>
      </button>
    } @else {
      <button type="button" mat-flat-button color="primary" class="right-icon-button" [class.spinner]="isSaving" [disabled]="isSaving"
        [attr.aria-label]="'common.labels.downloadResultDocument' | transloco" data-testid="result-document-button" [matMenuTriggerFor]="downloadMenu">
        <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">keyboard_arrow_down</mat-icon>
        <mat-label>{{ labels.documents }}</mat-label>
      </button>
    }

    <mat-menu #downloadMenu="matMenu">
      @if (!hideResultDocument && hasResultDocument()) {
        <button type="button" mat-menu-item (click)="openResultDocument()">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ labels.registryDocument }}</span>
        </button>
      }

      @if (!hideRegHubDocument && hasRegHubDocument()) {
        <button type="button" mat-menu-item (click)="openRegHubDocument()">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ labels.regHubDocument }}</span>
        </button>
      }

      @if (showParsedResultsJson && this.searchResult?.parsedResultID) {
        <button type="button" mat-menu-item (click)="downloadParsedResult()">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ labels.jsonDocument }}</span>
        </button>
      }

      @if(uboTreeNode?.document) {
        <button type="button" mat-menu-item (click)="openHubReportDocument()">
          <mat-icon color="primary">download</mat-icon>
          <span class="primary">{{ labels.hubReportDocument }}</span>
        </button>
      }
    </mat-menu>
  </div>
}
